import {
  renderMainRightCell,
  renderMainLeftCell,
  renderSoftLeftCell,
  renderColumnGaps,
  renderRowGaps,
  renderSectionHeader
} from '../helpers';

export const renderRiskMeasuresHeaderRow = (header, asOfDate) => {
  let rowString = `<tr>`;
  rowString += renderColumnGaps();
  rowString += renderMainLeftCell(header);
  rowString += renderColumnGaps();
  rowString += asOfDate ? renderSoftLeftCell(asOfDate) : renderColumnGaps();
  rowString += `</tr>`;
  return rowString;
};

export const renderRiskMeasuresRow = (label, value, asOfDate) => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(label);
  rowString += renderMainRightCell(value);
  rowString += renderColumnGaps();
  rowString += asOfDate ? renderSoftLeftCell(asOfDate) : renderColumnGaps();
  rowString += `</tr>`;
  return rowString;
};

export const riskMeasuresModule = data => {
  let moduleString = ``;
  moduleString += renderSectionHeader('Risk Measures');
  moduleString += renderRowGaps(3);
  moduleString += renderRiskMeasuresHeaderRow('Fund');
  moduleString += renderRiskMeasuresRow(data.standardDeviationLabel, data.standardDeviation, data.standardDeviationAsOfDate);
  moduleString += renderRiskMeasuresRow(data.sharpeRatioLabel, data.sharpeRatio);
  if (data.isMultipleIndex) {
    moduleString += renderRiskMeasuresHeaderRow(`American Funds Benchmark ${data.addSuperscript([data.fundCGIndexID, 'rSquared', 'beta', 'captureDown', 'captureUp'], '_afBenchmark_')}`, data.americanFundsBenchmarkAsOfDate);
    moduleString += renderRiskMeasuresHeaderRow(data.americanFundsBenchMark.indexLabel);
    moduleString += renderRiskMeasuresRow(data.americanFundsBenchMark.rSquaredLabel, data.americanFundsBenchMark.rSquared);
    moduleString += renderRiskMeasuresRow(data.americanFundsBenchMark.betaLabel, data.americanFundsBenchMark.beta);
    moduleString += renderRiskMeasuresRow(data.americanFundsBenchMark.captureRatioDownLabel, data.americanFundsBenchMark.captureRatioDown);
    moduleString += renderRiskMeasuresRow(data.americanFundsBenchMark.captureRatioUpLabel, data.americanFundsBenchMark.captureRatioUp);
  }
  const mStarHeader = data.isMultipleIndex ?
    `Morningstar Benchmark ${data.addSuperscript([data.fundCGIndexID, 'NF_MS_RSQ_AFR', 'NF_MS_BETA_AF', 'NF_MS_DCAPRAT', 'NF_MS_UCAPRAT'], '_afMorningStarBenchmark_')}` : `Insurance Series/Morningstar Benchmark ${data.addSuperscript([data.fundCGIndexID, 'NF_MS_RSQ_AFR', 'NF_MS_BETA_AF', 'NF_MS_DCAPRAT', 'NF_MS_UCAPRAT'], '_afMorningStarBenchmark_')}`;
  moduleString += renderRiskMeasuresHeaderRow(mStarHeader, data.morningstarBenchmarkAsOfDate);
  moduleString += renderRiskMeasuresHeaderRow(data.morningstarBenchmark.indexLabel);
  moduleString += renderRiskMeasuresRow(data.morningstarBenchmark.rSquaredLabel, data.morningstarBenchmark.rSquared);
  moduleString += renderRiskMeasuresRow(data.morningstarBenchmark.betaLabel, data.morningstarBenchmark.beta);
  moduleString += renderRiskMeasuresRow(data.morningstarBenchmark.captureRatioDownLabel, data.morningstarBenchmark.captureRatioDown);
  moduleString += renderRiskMeasuresRow(data.morningstarBenchmark.captureRatioUpLabel, data.morningstarBenchmark.captureRatioUp);
  moduleString += renderRowGaps(2);
  return moduleString;
};
